import Avatar from '@mui/material/Avatar';
import AvatarGroup from '@mui/material/AvatarGroup';
import { useSelector, useDispatch } from 'react-redux';
import NavLinkAdapter from '@fuse/core/NavLinkAdapter';
import FileManagementHeader from 'app/shared-components/file/FileManagementHeader';
import ChannelLogo from 'app/shared-components/channel/ChannelLogo';
import { useParams, useLocation, useNavigate } from 'react-router-dom';
import { useEffect} from 'react';
import {
    selectChannel,
    selectAllMembersByChannelId,
    fetchMembersByChannelId,
    selectMembersStatusByChannelId, selectMembersByChannelIdAndRole
} from 'app/store/channelsSlice';
import { selectEntryById, selectChannelClientByIds, selectClientsByGroupId } from 'app/store/groupsSlice';
import { searchPosts } from 'app/store/postSlice';
import { setSearchResults, selectSearchText, setSearchText } from './store/channelAppSlice';
import { selectCurrentFolder } from 'app/store/fileItemsSlice';
import { setAiDialogDetails } from 'app/store/aiChatSlice';
import { dispatchResultAction } from 'app/shared-components/utils';
import PageHeader from 'app/shared-components/layout/PageHeader';
import DefaultButton from 'app/shared-components/layout/DefaultButton';
import AIChatButton from 'app/shared-components/aichat/AIChatButton';
import ChannelSettingsButton from 'app/shared-components/channel/ChannelSettingsButton';
import TooltipButton from 'app/shared-components/layout/TooltipButton';
import DropdownSearch from 'app/shared-components/layout/DropdownSearch';
import useLocationStatus from './useLocationStatus';
import useThemeMediaQuery from '@fuse/hooks/useThemeMediaQuery';
import capitalizeFirstLetter from 'app/shared-components/util/capitalizeFirstLetter';

function ChannelAppHeader({onSetSidebarOpen, type, breadcrumb, button}) {
  const routeParams = useParams();
  const location = useLocation();
  const navigate= useNavigate();
  const dispatch= useDispatch();
  const { groupId, channelId, clientId} = routeParams;
  const {isTopics, isAdmin, isFiles, isMembers, isClients, isChannel, isClient, isHome} = useLocationStatus();
  const folderId= useSelector(selectCurrentFolder); 
  const group= useSelector(selectChannel(groupId));
  const channel = useSelector(selectChannel(channelId));
  const members= useSelector(selectAllMembersByChannelId(groupId));
  const adminMembers= useSelector(selectMembersByChannelIdAndRole(groupId, 'admin'));
  const adminMemberStatus= useSelector(selectMembersStatusByChannelId(groupId, 'admin'));
  const guestMembers= useSelector(selectMembersByChannelIdAndRole(groupId, 'guest'));
  const guestMemberStatus= useSelector(selectMembersStatusByChannelId(groupId, 'guest'));
  const nonGuestMembers= members.filter(member => guestMembers.findIndex(guest => guest.id === member.id) === -1);
  console.log("ChannelAppHeader")
  console.log(nonGuestMembers);
  const client = useSelector(selectChannelClientByIds(groupId, clientId));
  const clients= useSelector(selectClientsByGroupId(groupId));
  const clientMembers= useSelector(selectAllMembersByChannelId(client?.channelId));
  const teamClient= useSelector(selectChannelClientByIds(groupId, clientId));
  const clientChannelId = teamClient?.channelId;
  const topicId= isChannel ? channelId : undefined;
  const topicMembers =  useSelector(selectAllMembersByChannelId(topicId));
  const topicMemberStatus= useSelector(selectMembersStatusByChannelId(topicId));
  const topicEntity= channel?.entity;


  // console.log("topicId: " + topicId);
  // console.log(topicEntity);
  // console.log(topicMembers);
  const searchText= useSelector(selectSearchText);
  const topicBaseMembers= isChannel && topicEntity ?
      (topicEntity.inheritMembers ? nonGuestMembers : topicEntity.inheritAdminMembers ? adminMembers : []) :
      [];
  const topicEffectiveMembers= topicBaseMembers.concat(topicMembers);
  //console.log(topicEffectiveMembers);
  const showMembers= client ? clientMembers :
      isChannel ? topicEffectiveMembers :
          nonGuestMembers;
  //console.log(showMembers);
  const showCount= clientMembers ? clientMembers.length : isChannel ? topicEffectiveMembers.length : group.memberCount;
  const entry= useSelector(selectEntryById(groupId));
  const unread= entry && (entry.unread || entry.topicsUnread || entry.clientsUnread);
  const isMobile = useThemeMediaQuery((theme) => theme.breakpoints.down('sm'));
  const avatarNumber= isMobile ? 6 : 15;
  const appBaseUrl= "/apps/" + type + "/" + groupId;
  const breadcrumbSeparator= isMobile ? "" : "> ";
  if (!group) return null;
  let useBreadcrumb = breadcrumb ? breadcrumb : 
                     isTopics ? breadcrumbSeparator + "Topics" : 
                     isAdmin ? breadcrumbSeparator + "Admin" :
                     isClients ? breadcrumbSeparator + "Clients" : 
                     client ? breadcrumbSeparator + client.firstName + " " + client.lastName + " ": 
                     channel ? breadcrumbSeparator + channel.name : "";
  if (isMembers) useBreadcrumb= useBreadcrumb + breadcrumbSeparator + "Members";
  const membersLink =  isClient ? appBaseUrl + "/client/" + clientId + "/members" :
                              isChannel ? appBaseUrl + "/channel/" + channelId + "/members" :
                                  appBaseUrl + "/members";

  const filesBasePath= appBaseUrl + "/files";
  const searchPlaceholder= "Search " + (channel ? channel.name : group.name);
  const useButton= button ? button : 
                            isTopics ? { icon: "heroicons-outline:plus",  text: "New Topic", link: "topic/new" } :
                            undefined;


    useEffect(() => {
        if (topicId && topicMemberStatus === 'idle'){
            dispatch(fetchMembersByChannelId({channelId: topicId}));
        }
    }, [ topicId, topicMemberStatus ]);

    useEffect(() => {
        if (groupId && adminMemberStatus === 'idle'){
            dispatch(fetchMembersByChannelId({channelId: groupId, role: 'admin'}));
        }
    }, [ groupId, adminMemberStatus ]);

    useEffect(() => {
        if (groupId && guestMemberStatus === 'idle'){
            dispatch(fetchMembersByChannelId({channelId: groupId, role: 'guest'}));
        }
    }, [ groupId, guestMemberStatus ]);

  
  const onSearch = (text) => {
	  const query= {keywords: text};
	  
	  //If its the top level, we need to add in any authrized client channels
	  if (isHome){
		  query.rootChannelIds= [groupId];
		  if (clients && clients.length > 0){
			  for (let i in clients) {
				const c= clients[i];
				query.rootChannelIds.push(c.channelId);
			  }
		  }
	  }
	  //otherwise just use the channelid
	  else if (isChannel){
		  query.channelIds= [channelId];
	  }
	  else if (isClient){
		  query.channelIds= client ? [client.channelId] : undefined;
	  }
	  else return;
	  
	  //Execute query
	  dispatch(setSearchText(text));
	  dispatch(searchPosts(query)).then((resp) => {
	  	 dispatchResultAction(dispatch, resp, setSearchResults(resp.payload));
	  });
	  if (!location.pathname.endsWith('searchresults')) navigate(location.pathname + '/searchresults');
  }
        
  if (isFiles) return (
      <FileManagementHeader rootName={group?.name}
                            onSetSidebarOpen={onSetSidebarOpen}
                            basePath={filesBasePath}
                            avatar={<ChannelLogo channel={group} />}/>
  )
  else return (
	 <PageHeader title={group.name} breadcrumbs={useBreadcrumb} unread={unread} 
	             onMenuClick={(ev) => onSetSidebarOpen(true)}
	             avatar={<ChannelLogo channel={group} />}
	             button={useButton ? 
                Array.isArray(useButton) ? 
                  useButton.map((btn, index) => (
                    <DefaultButton key={index} icon={btn.icon} text={btn.text} link={btn.link} onClick={btn.onClick} />
                  )) :
                  <DefaultButton icon={useButton.icon} text={useButton.text} link={useButton.link} onClick={useButton.onClick} /> : 
	                    <>
	                    <NavLinkAdapter to={membersLink} >
      				           <AvatarGroup max={avatarNumber} total={showCount}>
      				            {showMembers.map((user) => (
        								   <Avatar key={user.id} className="flex-0 w-32 h-32" alt={user.firstName} src={user.profileImageUrl}>
        						            {user.firstName[0]}
        						        </Avatar>
        					         ))}
      				           </AvatarGroup>
      				        </NavLinkAdapter>
				              {isChannel || isHome || isClient ? 
				                <>
                           <DropdownSearch 
                            placeholderText={searchPlaceholder}
                            tooltip={searchPlaceholder}
                            value={searchText}
                            executeSearchFunction={onSearch}/> 
                            
                          <AIChatButton channelId={ channelId ? channelId : groupId }
                                        agentName="RecordAgent"
                                        tooltip="Open AI Assistant"/>

                          <ChannelSettingsButton channelId={ isClient ? clientChannelId : isChannel ? channelId  : groupId } rootChannelId={ (isChannel || isClient) ? groupId : null } channelType={ group?.type }/>
		                    </> : null}
				            </>} 
	  />
  )
}

export default ChannelAppHeader;
